module.exports = __webpack_public_path__ + "static/media/get-wasabi.36a26aeb.png";